<template>
  <div class="main-content sn-content">
    <!--  <el-card class="box-card clearfix">-->
    <el-row style="margin-bottom: 15px;background: #f4f4f5;padding: 15px 15px 0 0">
      <el-col :xs="12" :sm="16">
        <el-form class="search-form" ref="form">
          <el-form-item label="机器码：" label-width="85px">
            <el-input v-model="mid" clearable placeholder="请输入授权码" size="small"></el-input>
          </el-form-item>
          <el-form-item label="客户名称：" label-width="85px">
            <CustomerSelect v-model="customerId"></CustomerSelect>
          </el-form-item>


          <el-form-item label="" label-width="85px">
            <el-button class="pxy-primary" size="small" @click="formSearch()">查询</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-table
      :data="localSnList">
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" inline class="demo-table-expand">
            <el-form-item label="授权码">
              <span>{{ props.row.sn }}</span>
            </el-form-item>
            <el-form-item label="标签">
              <span>{{ props.row.tag }}</span>
            </el-form-item>
            <el-form-item label="SDKID">
              <span>{{ props.row.sdkId }}</span>
            </el-form-item>
            <el-form-item label="状态">
              <span v-if="props.row.status == '1'" style="color: #F56C6C">无效 </span>
              <span v-else-if="notInForce(props.row)" style="color: #E6A23C">未生效</span>
              <span v-else-if="expired(props.row)" style="color: #F56C6C">已过期</span>
              <span v-else="props.row.status == '0'" style="color: #67C23A">有效 </span>

            </el-form-item>
            <el-form-item label="产品类型">
              <span v-if="props.row.prodType == 'SIM'">云雀仿真 </span>
              <span v-if="props.row.prodType == 'VR'">云雀VR </span>
              <span v-if="props.row.prodType == 'AR'">云雀AR </span>
              <span v-if="props.row.prodType == 'ALL'">通用类型 </span>
            </el-form-item>

            <el-form-item  label="小班教室">
              <span v-if="props.row.solType == 'S001'">是</span>
              <span v-else>否</span>
            </el-form-item>
            <el-form-item label="授权方式">
              <span v-if="props.row.licenseType == 'CLOUDSN'">云授权 </span>
              <span v-if="props.row.licenseType == 'LOCALSN'">本地授权</span>
            </el-form-item>
            <el-form-item label="授权类型">
              <span v-if="props.row.snType == 'B'">标准版商业授权</span>
              <span v-if="props.row.snType == 'C'">开发版授权
                  <br/>
                  ({{props.row.authLevel == 1 ? '等级一':(props.row.authLevel == 2 ? '等级二':'等级三')}})
                </span>
              <span v-if="props.row.snType == 'F'">免费版授权</span>
              <span v-if="props.row.snType == 'D'">免费版开发授权</span>
            </el-form-item>

            <el-form-item label="节点数">
              <span>{{ props.row.serverCnt }}</span>
            </el-form-item>

            <el-form-item label="并发数">
              <span>{{ props.row.connCnt }}</span>
            </el-form-item>
            <el-form-item label="VR并发数">
              <span>{{ props.row.vrConnCnt }}</span>
            </el-form-item>

            <el-form-item label="开始时间">
              <span>{{ props.row.startDate }}  </span>
            </el-form-item>
            <el-form-item label="结束时间">
              <span>{{ props.row.endDate  }}  </span>
            </el-form-item>

            <el-form-item  label="是否显示Logo">
              <span v-if="props.row.wm == 'Y'">是</span>
              <span v-if="props.row.wm == '1'">商业版Logo</span>
              <span v-if="props.row.wm == '2'">个人版Logo</span>
              <span v-if="props.row.wm == '3'">行业伙伴Logo</span>
              <span v-if="props.row.wm == 'N'">否</span>
            </el-form-item>
            <el-form-item  label="数据通道">
              <span v-if="props.row.dcsAuth == 'Y'">是</span>
              <span v-if="props.row.dcsAuth == 'N'">否</span>
            </el-form-item>
            <el-form-item  label="互动模式">
              <span v-if="props.row.playModeEnable == '1'">是</span>
              <span v-if="props.row.playModeEnable == '0'">否</span>
            </el-form-item>
            <el-form-item  label="启动像素流送">
              <span v-if="props.row.pixelStreamingEnable == '1'">是</span>
              <span v-if="props.row.pixelStreamingEnable == '0'">否</span>
            </el-form-item>
            <el-form-item  label="智能语音">
              <span v-if="props.row.scs == '1'">是</span>
              <span v-if="props.row.scs == '0'">否</span>
            </el-form-item>
            <el-form-item  label="虚拟声卡">
              <span v-if="props.row.audioDriver == '1'">是</span>
              <span v-if="props.row.audioDriver == '0'">否</span>
            </el-form-item>
            <el-form-item v-if="props.row.audioDriver == '1'" label="虚拟声卡路数">
              <span>{{ props.row.lineCnt }} 路</span>
            </el-form-item>
            <el-form-item  label="语音输入">
              <span v-if="props.row.audioInput == '1'">是</span>
              <span v-if="props.row.audioInput == '0'">否</span>
            </el-form-item>
            <el-form-item  label="视频输入">
              <span v-if="props.row.videoInput == '1'">是</span>
              <span v-if="props.row.videoInput == '0'">否</span>
            </el-form-item>

            <el-form-item  label="启用三方客户端接入">
              <span v-if="props.row.outsideClientEnable == '1'">是</span>
              <span v-if="props.row.outsideClientEnable == '0'">否</span>
            </el-form-item>
            <el-form-item label="来源">
              <span>{{ props.row.upstreamSystem }}</span>
            </el-form-item>
            <el-form-item label="备注" style="width: 100%">
              <el-input style="width: 100%"  type="textarea"   :autosize="{ minRows: 1, maxRows: 5}" v-model="props.row.note"  readonly="true" ></el-input>
            </el-form-item>
            <el-form-item label="创建时间">
              <span> {{props.row.createDate }}</span>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column
        prop="sn"
        label="授权码"
        width="350px">
      </el-table-column>
      <el-table-column
        prop="tag"
        label="标签">
      </el-table-column>
      <el-table-column
        label="授权类型">
        <template slot-scope="scope">
          <span v-if="scope.row.snType == 'B'"> 标准版</span>
          <span v-if="scope.row.snType == 'C'"> 开发版</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="connCnt"
        label="最大并发数"
      >
      </el-table-column>
      <el-table-column
        label="状态" >
        <template slot-scope="scope">
          <span v-if="scope.row.status == '1'" style="color: #F56C6C">无效 </span>
          <span v-else-if="notInForce(scope.row)" style="color: #E6A23C">未生效</span>
          <span v-else-if="expired(scope.row)" style="color: #F56C6C">已过期</span>
          <span v-else="scope.row.status == '0'" style="color: #67C23A">有效 </span>
        </template>
      </el-table-column>
      <el-table-column
        label="开始时间">
        <template slot-scope="scope">
          <span> {{scope.row.startDate }}</span>

        </template>
      </el-table-column>
      <el-table-column
        label="结束时间">
        <template slot-scope="scope">
          <span> {{scope.row.endDate }}</span>

        </template>
      </el-table-column>

      <el-table-column
        prop="createDate"
        label="创建时间">
        <template slot-scope="scope">
          {{scope.row.createDate}}
        </template>
      </el-table-column>
      <el-table-column
        label="操作" width="80px">
        <template slot-scope="scope">
          <router-link icon="el-icon-edit"
            style="color: #FF6B00;font-size: 12px"
            :to="{ path: '/localSn/update', query: { sn: scope.row.sn, mid :scope.row.mid,
               customerId:scope.row.customerId,redirect:'/localSn/index' }}">
            延期
          </router-link>
        </template>
      </el-table-column>

    </el-table>

    <PageComponent ref="pageInfo"></PageComponent>
  </div>
</template>

<script>
  import {Message} from "element-ui";
  import PageComponent from '@/components/pageInfo/PageComponent'
  import CustomerSelect from '@/views/System/DataBoard/Components/customerSelect.vue'

  export default {
    components: {PageComponent, CustomerSelect},
    data() {
      return {
        localSnList: [],
        mid: '',
        sn: '',
        customerId: '',
      }
    },
    created() {

    },
    computed: {
      user() {
        return this.$store.state.user;
      },
    },
    methods: {
      getLocalSn: function () {
        var params = {};
        params.mid = this.mid;
        params.customerId = this.customerId;
        params.page = this.$refs.pageInfo.currentPage;
        params.pageSize = 10;
        this.getRequest('/localSn/list', params).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.localSnList = resp.data.result.records;
              console.log(this.localSnList)
              this.$refs.pageInfo.outputPagenator(resp.data.result.total, resp.data.result.size);
            } else {
              Message.error(resp.data.message);
            }
          }
        })
      },

      formSearch() {
        this.getLocalSn()
      },
      notInForce: function (row) {
        var date = this.getDateTime();
        return row.startDate > date
      },
      expired: function (row) {
        var date = this.getDateTime();
        return row.endDate < date
      },
      getDateTime: function () {
        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var day = date.getDate();
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var seconds = date.getSeconds();
        if (month < 10) {
          month = "0" + month;
        }
        if (day < 10) {
          day = "0" + day;
        }
        if (hours < 10) {
          hours = "0" + hours;
        }
        if (minutes < 10) {
          minutes = "0" + minutes;
        }
        if(seconds < 10){
          seconds = "0" + seconds;
        }
        return year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
      },
    },
    mounted: function () {
      this.mid = this.$route.query.mid
      this.sn = this.$route.query.sn
      this.customerId = this.$route.query.customerId
      if (this.mid) {
        this.getLocalSn()
      }

      this.$refs.pageInfo.initPagenator(this.getLocalSn, null);
    },
    beforeDestroy() {

    }
  }
</script>
<style>
  .demo-table-expand {
    font-size: 0;
  }

  .demo-table-expand label {
    width: 180px;
    color: #99a9bf;
  }

  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: calc(50% - 50px);
    margin-left: 50px;
  }

  .balance-tip {
    color: #F56C6C;
  }
</style>
